var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaterTreatmentPlant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 2.68C3 2.30445 3.32236 2 3.72 2H20.28C20.6776 2 21 2.30445 21 2.68V14.4516C21 14.6418 20.9157 14.8233 20.7675 14.952L12.4875 22.1464C12.2119 22.3859 11.7881 22.3859 11.5125 22.1464L3.23252 14.952C3.08433 14.8233 3 14.6418 3 14.4516V2.68Z",
    stroke: "#637381"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.63013 10.3304C3.63013 9.95484 3.95248 9.65039 4.35013 9.65039H19.5601C19.9578 9.65039 20.2801 9.95484 20.2801 10.3304V14.1152C20.2801 14.3035 20.1975 14.4834 20.0518 14.612L12.4892 21.2887C12.2135 21.532 11.7857 21.5331 11.5086 21.2911L3.86129 14.6123C3.71392 14.4836 3.63013 14.3026 3.63013 14.113V10.3304Z",
    fill: "#2486FD",
    fillOpacity: 0.2,
    stroke: "#1070CA",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterTreatmentPlant);
export default __webpack_public_path__ + "static/media/water_treatment_plant.0852a0da0b981f95add9416b914cd736.svg";
export { ForwardRef as ReactComponent };